import { Col, Form, Row } from 'antd';
import { useTranslate } from '@refinedev/core';

import TextInput from 'components/text/textInput';
import TextAreaInput from 'components/textarea/textAreaInput';
import constants from 'core/constants/Constants';
import RangeInput from 'components/date/rangeInput';
import SegmentInput from 'components/segment/SegmentInput';
import DropdownInput from 'components/dropdown/dropDownInput';
import useRulesDropdown from 'pages/rules/RulesDropdown';
import disabledDate from 'core/utils/disabledDate';
import regex from 'core/constants/Regex';

const RuleGroupFields = ({
  formData,
  eventHandler,
  stateData,
  staticData,
  configData,
}: any) => {
  const t = useTranslate();
  const { formProps } = formData;
  const { onFinishHandler } = eventHandler;
  const { ruleGroupDate, groupHasRules } = stateData;
  const { type: pageType } = staticData;
  const { disabled } = configData;
  const { ruleType } = useRulesDropdown();

  const activeStatus = [
    { label: t('rules.ruleActive'), value: true },
    { label: t('rules.ruleInactive'), value: false },
  ];
  const initialValues = { rule_group_is_active: true };
  const isValuesPresent = formProps?.initialValues?.results || initialValues;

  return (
    <Form
      {...formProps}
      id="rule-change-group-form"
      onFinish={onFinishHandler}
      initialValues={isValuesPresent}
      disabled={pageType === 'Show' || disabled}
      size="large"
      layout="vertical"
    >
      <Row gutter={16}>
        <Col xs={24} lg={12}>
          <TextInput
            label={t('ruleGroup.ruleGroupName')}
            name="rule_group_name"
            required={true}
            message={t('ruleGroup.messages.ruleGroupName')}
            placeholder={t('ruleGroup.messages.ruleGroupName')}
            disabled={pageType === 'Show'}
            rules={{
              pattern: regex.nameCheck,
              message: t('errorMessages.ruleGroupNameValidMsg'),
            }}
          />
        </Col>
        <Col xs={24} lg={12}>
          <RangeInput
            label={t('ruleGroup.ruleGroupDate')}
            name="rule_group_date"
            required={true}
            message={t('ruleGroup.messages.ruleGroupDate')}
            format={constants.dateFormat}
            disabledDate={(current) => disabledDate(current, ruleGroupDate)}
            disabled={pageType === 'Show'}
          />
        </Col>
        <Col xs={24} lg={12}>
          <DropdownInput
            label={t('rules.ruleType')}
            name="rule_type"
            required={true}
            optionList={ruleType}
            message={t('rules.messages.ruleType')}
            placeholder={t('rules.messages.ruleType')}
            disabled={
              pageType === 'Show' || (groupHasRules && groupHasRules > 0)
            }
          />
        </Col>
        <Col xs={24} lg={12}>
          <label className="floating-label">{t('common.status')}</label>
          <SegmentInput
            name="rule_group_is_active"
            optionList={activeStatus}
            disabled={pageType === 'Show'}
          />
        </Col>
        <Col xs={24} lg={24}>
          <TextAreaInput
            label={t('ruleGroup.ruleGroupDescription')}
            name="rule_group_description"
            message={t('ruleGroup.messages.ruleGroupDescription')}
            placeholder={t('ruleGroup.messages.ruleGroupDescription')}
            rows={4}
            required={false}
            disabled={pageType === 'Show'}
          />
        </Col>
      </Row>
    </Form>
  );
};

export default RuleGroupFields;
